export const HOV_THEME_START_HUE_CSS_VARIABLE = "--hov-theme-start-hue";

export function applyHovThemeHue(
  element: HTMLElement,
  themeHue: number | null,
): void {
  if (themeHue === null) {
    element.removeAttribute("data-has-nhov-theme");
    element.style.removeProperty(HOV_THEME_START_HUE_CSS_VARIABLE);
    return;
  }

  element.dataset.hasNhovTheme = "true";
  element.style.setProperty(HOV_THEME_START_HUE_CSS_VARIABLE, String(themeHue));
}
